module.exports = __webpack_public_path__ + "static/img/defaultHead.d02352a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultHead.png
// module id = 7ADV
// module chunks = 4